import React from 'react';
import PropTypes from 'prop-types';
import SeeDetails from '../../molecules/btn/seeDetails';
//is H3 because its supposed to be inside a section (h2) that's not the main section (h1)
const CardHeader = ({
  title, roomIndex, guests, className, seeDetails,
}) => (
  <React.Fragment>
    <h3
      className={`flex justify-between w-full uppercase leading-tight ${className || ''}`}
    >
      <span className="font-bold">{title}</span>
      {roomIndex && <span className="text-gray-600">Room {roomIndex}</span>}
    </h3>
    <div className="flex justify-between mb-2">
      { seeDetails && <SeeDetails onClick={seeDetails} />}
      { guests && <span className="ml-auto text-gray-600">{guests}</span>}
    </div>
  </React.Fragment>
);

CardHeader.propTypes = {
  title: PropTypes.string.isRequired,
  roomIndex: PropTypes.number,
  seeDetails: PropTypes.func,
};

export default CardHeader;
